<template>
  <div class="QA">
    <ListTitle :title="title" :titleImg="titleImg" h />
    <v-container class="py-12">
      <v-row>
        <v-col>
          <NoticeContent
            :tree="false"
            :squirrel="true"
            :bird="true"
            :bgColor="'rgba(178,171,158,0.6)'"
          >
            <div v-for="(item, idx) in qaList" :key="idx">
              <QAItem :title="item.title" :content="item.content" />
            </div>
          </NoticeContent>
        </v-col>
      </v-row>
    </v-container>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
import NoticeContent from "@/components/home/section2/NoticeContent.vue";
import QAItem from "@/components/home/section2/QAItem.vue";
export default {
  props: {
    title: {
      type: String,
      default: "Q&A"
    },
    titleImg: {
      type: String,
      default: "common/icon_QA.svg"
    }
  },
  data() {
    return {
      qaList: [
        {
          title: "Q：請問如何加入會員？",
          content: "A：可以在頁面的右上角點選「登入會員」→「註冊會員」。"
        },
        {
          title: "Q：請問如何加入會員？",
          content: "A：可以在頁面的右上角點選「登入會員」→「註冊會員」。"
        },
        {
          title: "Q：請問如何加入會員？",
          content: "A：可以在頁面的右上角點選「登入會員」→「註冊會員」。"
        },
        {
          title: "Q：請問如何加入會員？",
          content: "A：可以在頁面的右上角點選「登入會員」→「註冊會員」。"
        }
      ]
    };
  },
  components: {
    Footer,
    NoticeContent,
    QAItem,
    ListTitle
  },
  methods: {
    setQAList(list) {
      if (list !== null && typeof list.length !== "undefined") {
        this.qaList = [];
        for (let i = 0; i < list.length; i++) {
          let item = {
            title: list[i].Question,
            content: list[i].Answer
          };
          this.qaList.push(item);
        }
      }
    }
  },
  mounted() {
    this.qaList = this.$store.state.announce.qaList;
    if (this.qaList.length == 0) {
      this.$store.dispatch("getQAList").then(() => {
        this.qaList = this.$store.state.announce.qaList;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.QA {
  background-color: #f6edd9;
  @include pcAndpad {
    min-height: 100vh;
  }
  // background-size: 100%;
  // background-repeat: no-repeat;
  // position: relative;
  // background-position: 50% 50%;
  // background-image: url("~@/assets/images/home/sect4_bg.png");
}
</style>
